import { REACT_APP_PROMPT_AI_COPYWRITER_URL, apiPath } from '../apiPath';
import aiCreateApiInstance from '../aiCreateApiInstance';

const api = aiCreateApiInstance(REACT_APP_PROMPT_AI_COPYWRITER_URL);

export const getPromptManagerListAPI = (params) => api.get(apiPath.promptsManager, { params });
export const createPromptManagerAPI = (data) => api.post(apiPath.promptsManager, data);
export const updatePromptManagerAPI = (data) => api.put(`${ apiPath.promptsManager }${ data.id }`, data);
export const deletePromptManagerAPI = (id) => api.delete(`${ apiPath.promptsManager }${ id }`);
export const togglePromptManagerAPI = (data) => api.put(`${ apiPath.promptsManager }${ data.id }/toggle?is_active=${ data.is_active }`);
export const aiGenerateContentAPI = (data) => api.post(`${ apiPath.aiGenerateContent }`, data);
export const aiReGenerateContentAPI = (data) => api.post(`${ apiPath.aiReGenerateContent }`, data);